import WorkspaceGroups from "./workspace-groups";

export default WorkspaceGroups;
